// special

<template>
    <component v-if="specComponent" :is="specComponent" :specData="specData" @submit="onSubmit" @cancel="onCancel" />
</template>
<script>
import report from './report'
export default {
	name: 'special',
	components: {
		report
	},
	props: {
		modulData: {
			type: Object,
			required: true,
			default: {},
		},
	},
	data: () => ({
	}),
	computed: {
		specData() {
			if(!this.modulData) return null
			const specData = Object.assign({}, this.modulData)
			return specData
		},
        specComponent() {
            if(!this.specData) return null
            return this.specData.meta.modelname
        }
	},
	methods: {
		onCancel() {
            this.$emit('cancelled')
		},
		onSubmit() {
            this.$emit('submitted')
		},
	},
	mounted() {
		//console.log('special mounted')
	},
	beforeMount() {
	},
};
</script>
<style>
</style>